module.exports = __webpack_public_path__ + "static/media/435_Closet.d8f1e377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Closet.jpg
// module id = 557
// module chunks = 0